import React from "react";
import { faTriangleExclamation, faMultiply, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Modal } from "react-bootstrap";
import { useState } from "react";
import { KeycloakGroup } from "../../../model/CarbonExternalModels";
import { Button, UserfulTooltip } from "userful-chronos-common-ui/dist";
import { useCarbonDispatch } from "../../../store/carbonStore";
import { deleteUserGroup } from "../../../store/userManagement/userManagementManager";
import { UserPermission } from "../../../model/CarbonPermissionModels";

interface IProps {
    group: KeycloakGroup;
    type: "DROPDOWN" | "ICON";
    permissions: UserPermission;
}

export default function UserGroupDelete(props: IProps) {
    const dispatch = useCarbonDispatch();

    const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

    if (!props.permissions.isUserSuppressor) return null;

    return (
        <>
            {props.type === "DROPDOWN" ? (
                <Dropdown.Item
                    onClick={() => {
                        setShowConfirmation(true);
                    }}
                >
                    <div className="gcm-icon-dropdown-menu-icon-container">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </div>
                    <p>Delete</p>
                </Dropdown.Item>
            ) : (
                <UserfulTooltip title={"Delete"}>
                    <button
                        className="iconButton"
                        onClick={() => {
                            setShowConfirmation(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                </UserfulTooltip>
            )}

            <Modal
                centered
                show={showConfirmation}
                onHide={() => {
                    setShowConfirmation(false);
                }}
            >
                <div className="gcm-pop-up-modal-wrapper">
                    <div className="gcm-pop-up-modal-wrapper-body">
                        <div className="gcm-pop-up-modal-wrapper-head">
                            <div className="gcm-pop-up-modal-wrapper-title">
                                <FontAwesomeIcon icon={faTriangleExclamation} />
                                <h1>Delete Permission Set</h1>
                            </div>
                            <Button
                                variant="secondary"
                                iconOnly
                                onClick={() => {
                                    setShowConfirmation(false);
                                }}
                            >
                                <FontAwesomeIcon icon={faMultiply} />
                            </Button>
                        </div>
                        <p>
                            Are you sure you want to delete the permission set: <strong>"{props.group.name}"</strong>?
                            This will permanentaly remove all the data related this permission set.
                        </p>
                    </div>
                    <div className="confirmationDialogHorizontalWrapper reversed">
                        <Button
                            variant="danger"
                            onClick={(e) => {
                                setShowConfirmation(false);

                                deleteUserGroup(props.group.id, "INTERNAL");
                            }}
                        >
                            Delete
                        </Button>
                        <Button
                            variant="secondary"
                            onClick={(e) => {
                                setShowConfirmation(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
}
